import React, { useEffect, useState } from "react";
import "../reminder.css";
import { Card, Col, DatePicker, Flex, message, Modal, Row, Select, Statistic, Table, Tag, Tooltip, Typography } from "antd";
import {
  CheckCircleFilled,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteFilled,
  EditFilled,
  ExclamationCircleOutlined,
  FilterOutlined,
  HistoryOutlined,
  PlusCircleFilled,
} from "@ant-design/icons";
import moment from "moment";
import { hideLoading, showLoading, useLoadingDispatch } from "../../../context/loadingContext";
import { Pagination } from "@mui/material";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import AuthService from "../../../Components/auth/AuthService";
import HelperTaskHistoryModal from "../../../Components/Modals/HelperTaskHistoryModal";
import { HelperReminderTasks, vehicleDueOptions } from "../../../Components/common/Constants";
import { styled } from "@mui/system";
import { showMessage } from "../../../Components/Utils/message";
import { encodeId } from "../../../Components/common/CommonFun";

const Auth = new AuthService();

const DataSheet = styled('div')`
  .ant-table-tbody > tr > td {
    border-bottom: '1px solid #b7b9bd';
  },
  .ant-card .ant-card-body {
    padding: 8px !important;
  }, 
`;

const CardStyleFilter = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;


const HelperReminders = () => {
  const navigate = useNavigate()
  const { Text } = Typography;
  const { Option } = Select;
  const { RangePicker } = DatePicker;

  var layoutDispatch = useLoadingDispatch();
  const [allHelpers, setAllHelpers] = React.useState([]);
  const [allReminders, setAllReminders] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const [pageChange, setPageChange] = React.useState(false);
  const [limit] = React.useState(50);
  const [totalPages, setTotalPages] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(null);

  const [isHistoryModalOpen, setIsHistoryModalOpen] = React.useState(false);
  const [historyRecord, setHistoryRecord] = React.useState([]);
  const [counts, setCounts] = React.useState({
    dueSoon: '',
    overDue: '',
    total: ''
  });

  const [filters, setFilters] = useState({
    dateRange: [dayjs().startOf("month"), dayjs().endOf("month")],
    helper: null,
    task: null,
    status: null
  });

  const infoItems = [
    { label: "Total Overdue Reminders", count: counts?.overDue || 0, color: "red", status: 1 },
    { label: "Total Due Soon Reminders", count: counts?.dueSoon || 0, color: "orange", status: 2 },
  ];


  const reminderColumns = [

    {
      title: 'Helper',
      render: (record) => {
        return record?.warehouse_helper_id
          ? allHelpers.filter((obj) => obj.id == record.warehouse_helper_id)[0]?.first_name
          : ""
      },
    },
    {
      title: 'Next Due',
      render: (record) => {
        return (
          <>
            <span>{record.status == 0 ? "-" : dayjs(record.due_date).format("DD-MM-YYYY")}</span>
          </>
        )
      }
    },
    {
      align: "center",
      title: "Status",
      render: ({ due_date, type, status }) => {
        const serviceObject = HelperReminderTasks.find((obj) => obj.id === type);
        const info = getStatusInfo(moment(due_date, "YYYY-MM-DD"), serviceObject?.thresholdDays);
        return (
          <>
            {status === 0 ? (
              <Tag color={"#575252"} icon={<CloseCircleOutlined />} style={{ marginLeft: '4px' }}>
                {'Inactive'}
              </Tag>
            ) : (
              <Tag color={info?.color} icon={info?.icon} style={{ marginLeft: '4px' }}>
                {info?.text}
              </Tag>
            )}
          </>
        );
      },
    },
    {
      align: "center",
      title: "Tasks",
      render: (record) => {
        const info = HelperReminderTasks.find((obj) => obj.id === record?.type);
        return (
          <>
            <span>{info?.title || ""}</span><br />
            <span style={{ fontSize: '10px', color: 'darkgrey' }}>{info?.message}</span>
          </>
        );
      },
    },
    {
      align: "center",
      title: "Last Completed",
      render: (record) => {
        return (
          <>
            <span>{record.last_completed ? moment(record.last_completed, "YYYY-MM-DD").format("YYYY-MM-DD") : null}</span>
          </>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "right",
      dataIndex: "",
      render(record) {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            {
              !record?.last_completed && (
                <Tooltip title="Delete">

                  <DeleteFilled
                    onClick={() => {
                      Modal.confirm({
                        title: 'Delete Reminder',
                        centered: true,
                        content: `Are you sure you want to delete this reminder?`,
                        onOk: () => handleDelete(record.id),
                        okText: 'Delete',
                        cancelText: 'Cancel',
                        width: 600,
                        okButtonProps: { size: "large" },
                        cancelButtonProps: { size: "large" },
                      });
                    }}
                    style={{ fontSize: "25px", cursor: "pointer", color: "#cd1437", marginRight: "5px", }}
                  />
                </Tooltip>
              )
            }
            {
              record?.last_completed && (
                <Tooltip title="History">
                  <HistoryOutlined
                    style={{
                      fontSize: "25px",
                      cursor: "pointer",
                      marginRight: "5px",
                    }}
                    onClick={() => {
                      getHistory(record)
                    }}
                  />
                </Tooltip>
              )
            }
            {record?.status != 0 && (
              <Tooltip title="Resolve">
                <CheckCircleFilled
                  style={{
                    fontSize: "25px",
                    cursor: "pointer",
                    marginRight: "5px",
                    color: "green",
                  }}
                  onClick={() => {
                    const hasedID = encodeId(record?.id)

                    navigate(`/helper_reminder/resolve/${hasedID}`)
                  }}
                />
              </Tooltip>
            )}
            <Tooltip title="Edit">
              <EditFilled
                style={{
                  fontSize: "25px",
                  cursor: "pointer",
                  marginRight: "5px",
                  color: "#006cb8",
                }}
                onClick={() => {
                  const hasedID = encodeId(record?.id)

                  navigate(`/helper_reminder/${hasedID}`)
                }}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const handleDelete = async (recordID) => {
    showLoading(layoutDispatch)
    const params = {
      method: "DELETE",
      body: JSON.stringify({
        id: recordID,
      }),
    };
    try {
      const res = await Auth.fetch('/warehouse-helper-reminder/reminder-warehouse-helper', params)
      if (res?.ack) {
        showMessage('success', res.message)
        search()
      } else {
        showMessage('error', res.message)
      }
    } catch (error) {
      console.log(error);
    } finally {
      hideLoading(layoutDispatch)
    }
  }

  const getHistory = async (data) => {
    const DataToSend = {
      warehouse_helper_id: data?.warehouse_helper_id,
      type: data?.type
    }
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch("/warehouse-helper-reminder/warehouse-helper-reminders-history", {
        method: "POST",
        body: JSON.stringify(DataToSend),
      })

      if (res?.ack) {
        console.log('res', res);
        if (res?.reminders.length > 0) {
          setHistoryRecord(res?.reminders)
          setIsHistoryModalOpen(true)
        } else {
          message?.info('No related history found')
        }
      } else {
        showMessage('error', res?.message)
      }
    } catch (error) {
      console.log(error);
    } finally {
      hideLoading(layoutDispatch)
    }
  }

  const getStatusInfo = (date, thresholdDays) => {
    const daysDifference = date.diff(moment(), "days");

    if (daysDifference < 0) {
      return {
        color: "#ff002a",
        text: "Overdue",
        icon: <CloseCircleOutlined />,
      };
    } else if (daysDifference == thresholdDays || (daysDifference < thresholdDays && daysDifference > 0) || daysDifference === 0) {
      return {
        color: "#ec942c",
        text: "Due Soon",
        icon: <ExclamationCircleOutlined />,
      };
    } else if (daysDifference > thresholdDays) {
      return {
        color: "#339900",
        text: "Upcoming",
        icon: <CheckCircleOutlined />,
      };
    }
  };

  const getAllHelpers = async () => {
    showLoading(layoutDispatch);
    try {
      const response = await Auth.fetch(`/helper/warehouse-helpers`);
      if (response) {
        hideLoading(layoutDispatch);
        if (response?.ack) {
          setAllHelpers(response.warehouse_helpers);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (value) => {
    setPage(value);
    setPageChange(true)
  };

  const search = async (download) => {
    let search = {};
    if (filters?.dateRange && filters?.dateRange[0] && filters?.dateRange[1]) {
      search.start_date = dayjs(filters?.dateRange[0]).format("YYYY-MM-DD");
      search.end_date = dayjs(filters?.dateRange[1]).format("YYYY-MM-DD");
    }
    if (filters?.helper) search.warehouse_helper_id = filters?.helper;
    if (filters?.task) search.type = filters?.task;
    if (filters?.status) search.status = filters?.status;
    if (page && pageChange) search.page = page;

    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch("/warehouse-helper-reminder/reminders-warehouse-helper", {
        method: "POST",
        body: JSON.stringify(search),
      })
      if (res?.ack) {
        console.log('res', res);
        setAllReminders(res?.reminders)
        setCounts((prev) => ({
          ...prev,
          dueSoon: res?.due_soon_count,
          overDue: res?.over_due_count,
        }))
        setTotalPages(Math.ceil(res?.total_count / limit));
        setTotalCount(res.total_count);

      } else {
        setAllReminders([])
        showMessage('error', res?.message)
      }
    } catch (err) {
      showMessage('error', 'something went wrong');
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  useEffect(() => {
    const timeOutId = setTimeout(() => search(), 1000);
    return () => clearTimeout(timeOutId);
  }, [
    filters?.dateRange,
    filters?.task,
    filters?.helper,
    filters?.status,
    page
  ]);

  useEffect(() => {
    getAllHelpers()
  }, [])

  return (
    <>
      <CardStyleFilter>
        <Card title={<><FilterOutlined style={{ color: '#6cb8ff' }} /> Helper Reminders</>} style={{ marginBottom: '10px' }}
          extra={
            <>
              <PlusCircleFilled style={{ fontSize: "30px", color: "#1677FF" }} onClick={() => navigate('/helper_reminder/new')} />
            </>
          }
        >
          <Row gutter={[6, 1]}>
            <Col xs={24} md={12} lg={6}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Date Range</label>
              <RangePicker
                style={{ width: '100%' }}
                value={filters.dateRange}
                onChange={(dates) => {
                  setFilters(prev => ({ ...prev, dateRange: dates }))
                  setPageChange(false)
                  setPage(1)
                }}
                format="DD-MM-YYYY"
                // allowClear={false}
              />
            </Col>

            <Col xs={24} md={12} lg={6}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Helper</label>
              <Select
                style={{
                  width: "100%",
                }}
                showSearch
                allowClear
                value={filters?.helper}
                placeholder="Helper"
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }

                onChange={(value) => {
                  setFilters(prev => ({ ...prev, helper: value }));
                  setPageChange(false)
                  setPage(1)
                }}
              >
                {allHelpers?.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item?.first_name}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Task</label>
              <Select
                style={{
                  width: "100%",
                }}
                showSearch
                allowClear
                value={filters?.task}
                placeholder="Task"
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }

                onChange={(value) => {
                  setFilters(prev => ({ ...prev, task: value }));
                  setPageChange(false)
                  setPage(1)
                }}
              >
                {HelperReminderTasks?.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item?.title}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Status</label>
              <Select
                style={{
                  width: "100%",
                }}
                showSearch
                allowClear
                value={filters?.status}
                placeholder="Status"
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }

                onChange={(value) => {
                  setFilters(prev => ({ ...prev, status: value }));
                  setPageChange(false)
                  setPage(1)
                }}
              >
                {vehicleDueOptions?.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item?.title}
                  </Option>
                ))}
              </Select>
            </Col>

          </Row>
        </Card>
      </CardStyleFilter>
      <DataSheet>
        <Row gutter={[16, 16]}>
          {infoItems.map((item, index) => (
            <Col xs={24} sm={12} md={12} lg={8} xl={8} key={index}>
              <Card
                hoverable={item.count > 0}
                onClick={() => {
                  if (item.count > 0) {
                    setFilters({ ...filters, dateRange: [null, null], status: item?.status, task: null, helper: null});
                    setPage(1);
                    setPageChange(false);
                  }
                }}
                style={{
                  borderRadius: 10,
                  cursor: item.count > 0 ? "pointer" : "not-allowed",
                  background: "#fff",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                  opacity: item.count > 0 ? 1 : 0.5,
                }}
              >
                <Row justify="space-between" align="middle">
                  <Col>
                    <span style={{ fontSize: 14, fontWeight: 500, color: "black" }}>
                      {item?.label}
                    </span>
                  </Col>
                  <Col>
                    <span style={{ fontSize: 20, fontWeight: 700, color: item?.color }}>
                      {item.count}
                    </span>
                  </Col>
                </Row>
              </Card>
            </Col>
          ))}
        </Row>
        <Table
          columns={reminderColumns}
          style={{ marginTop: '10px' }}
          pagination={false}
          dataSource={allReminders}
          footer={() => {
            const startRecord = (page - 1) * limit + 1;
            const endRecord = Math.min(page * limit, allReminders.length ? totalCount : 0);
            return `Showing ${startRecord}-${endRecord} of ${allReminders.length ? totalCount : "0"} Records`;
          }}
          scroll={{ x: 'max-content' }}
          rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
        />
        <Flex justify="end" style={{ margin: "10px" }}>
          <Pagination
            page={page}
            count={totalPages}
            variant="outlined"
            color="primary"
            onChange={handleChange}
          />
        </Flex>

        <HelperTaskHistoryModal isModalOpen={isHistoryModalOpen} setIsModalOpen={setIsHistoryModalOpen} history={historyRecord} setHistory={setHistoryRecord} />
      </DataSheet>
    </>
  );
};

export default HelperReminders;
